import { RootState } from '../store';

export const getSelectedShareClass = (state: RootState) => state.fundDetails.selectedShareClass;
export const getIsFundDetailsInvTrustDisclaimerAvailable = (state: RootState) =>
  state.fundDetails.isInvestmentTrustDisclaimerAvailable;
export const getFundName = (state: RootState) => state.fundDetails.name;
export const getAssetClassName = (state: RootState) => state.fundDetails.assetClassName;
export const getSubAssetClassName = (state: RootState) => state.fundDetails.subAssetClassName;
export const getFormJSON = (state: RootState) => state.fundDetails.formJson;
export const getShareclasses = (state: RootState) => state.fundDetails.shareClasses;
export const getAvailableTabs = (state: RootState) => state.fundDetails.availableTabs;
export const getIsFundDetailsLoading = (state: RootState) => state.fundDetails.isLoading;
export const getFundDetailsData = (state: RootState) => state.fundDetails;
export const getFundHeroType = (state: RootState) => state.fundDetails.fundHeroType;
export const isFundDetailsImportantInfoAvailable = (state: RootState) =>
  state.fundDetails.isFundDetailsImportantInfoAvailable;
